import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import Modal from '../components/Modal';
import { registerRateLimitErrorHandler } from '../utils/rateLimitHandler';

interface RateLimitErrorContextType {
  showRateLimitError: (message: string) => void;
}

const RateLimitErrorContext = createContext<RateLimitErrorContextType | undefined>(undefined);

export const useRateLimitError = () => {
  const context = useContext(RateLimitErrorContext);
  if (!context) {
    throw new Error('useRateLimitError must be used within RateLimitErrorProvider');
  }
  return context;
};

interface RateLimitErrorProviderProps {
  children: ReactNode;
}

export const RateLimitErrorProvider: React.FC<RateLimitErrorProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const showRateLimitError = (message: string) => {
    setErrorMessage(message);
    setShowModal(true);
  };

  // Registrar el handler globalmente cuando el componente se monta
  useEffect(() => {
    registerRateLimitErrorHandler(showRateLimitError);
  }, []);

  return (
    <RateLimitErrorContext.Provider value={{ showRateLimitError }}>
      {children}
      <Modal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setErrorMessage('');
        }}
        title="Límite de solicitudes alcanzado"
        onConfirm={() => {
          setShowModal(false);
          setErrorMessage('');
        }}
        confirmText="Entendido"
        cancelText=""
      >
        <p>{errorMessage || 'Has realizado demasiadas solicitudes. Por favor, espera unos minutos antes de intentar nuevamente.'}</p>
      </Modal>
    </RateLimitErrorContext.Provider>
  );
};
